import {
	Component,
	ViewChild,
	ViewContainerRef,
	ComponentFactoryResolver,
	OnInit,
	Input,
	ComponentRef
} from "@angular/core";

import { SDP } from "../../models";

@Component({
	selector: "sdp-generic-custom-component-column",
	templateUrl: "./customComponent-column.component.html"
})
export class CustomComponentColumnComponent implements OnInit {

	@Input()
	public componentConstructor!: SDP.ConstructorFunction<any>;

	@Input()
	public data!: any;

	@Input()
	public initFunc!: (component: ComponentRef<any>, data: any) => void;

	@ViewChild("custom", {
		read: ViewContainerRef,
		static: true
	})
	public viewContainerRef!: ViewContainerRef;

	constructor(
		public componentFactoryResolver: ComponentFactoryResolver
	) {
	}

	public ngOnInit() {
		const componentFactory = this.componentFactoryResolver.resolveComponentFactory(this.componentConstructor);
		const component = this.viewContainerRef.createComponent(componentFactory);
		this.initFunc(component, this.data);
	}
}
